import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, signal, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { IContentSection } from '../../interfaces/card-info.interface';

@Component({
  selector: 'app-content-section',
  imports: [],
  templateUrl: './content-section.html',
  styleUrl: './content-section.scss'
})
export class ContentSection implements OnInit, AfterViewInit {
  @Input() section!: IContentSection;
  /** Editorial alignment of the block: 'center' (default, matches the centered spine),
   *  'left' / 'right' for the alternating post-services rhythm. */
  @Input() align: 'left' | 'right' | 'center' = 'center';

  @ViewChild('root') root!: ElementRef<HTMLElement>;

  /** Arms the hidden reveal start-state — only when JS + motion are present, so SSR /
   *  no-JS / reduced-motion render fully visible. */
  protected revealReady = signal(false);
  /** Flips to the visible end-state when the section scrolls into view. */
  protected revealed = signal(false);

  private motionOK = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.motionOK = !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (this.motionOK) this.revealReady.set(true);
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId) || !this.motionOK) return;
    const el = this.root?.nativeElement;
    if (!el || !('IntersectionObserver' in window)) {
      this.revealed.set(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            this.revealed.set(true);
            io.disconnect();
            break;
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' },
    );
    io.observe(el);
  }
}
